import api from '../config/axios';

export const getConversations = () => api.get('/chat/conversations');
export const getMessages = (studentId, page = 1) =>
  api.get(`/chat/${studentId}?page=${page}&limit=50`);
export const sendMessage = (studentId, content, attachments = []) =>
  api.post(`/chat/${studentId}`, { content, attachments });
export const markAsRead = (studentId) =>
  api.patch(`/chat/${studentId}/read`);
export const getAvailableStudents = (search = '') =>
  api.get(`/chat/available-students?search=${encodeURIComponent(search)}`);
